import { render, staticRenderFns } from "./ProdutoFormulario.vue?vue&type=template&id=836e43ae"
import script from "./ProdutoFormulario.vue?vue&type=script&lang=js"
export * from "./ProdutoFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports